<script setup lang="ts">
import {ref} from "vue";
import AllCourseItem from "components/dialog/common/innner/AllCourseItem.vue";
import {IncludeCourse} from "@/types";
import {CourseService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import {Search} from "@element-plus/icons-vue";

const visible = ref(false)
const id = ref(0)
const title = ref('')
const type = ref(1)

let allCourseItems: IncludeCourse[] = []
const courses = ref<IncludeCourse[]>([])

const init = async (_type: number, _id: number) => {
  id.value = _id
  type.value = _type
  title.value = ''
  try {
    const res = await CourseService.getAllCourseList({
      id: id.value,
      type: type.value,
    })
    if (res.data.code === 200) {
      allCourseItems = res.data.data || []
      courses.value = allCourseItems
      visible.value = true
    } else {
      ElNotification.error({
        title: "获取课程列表失败",
        message: res.data.msg,
        type: "error",
      })
    }
  } catch (error) {
    console.warn(error);
  }
}

const hide = () => {
  visible.value = false
  allCourseItems = []
}

const emit = defineEmits(["addCourse"])

const onSure = () => {
  // 遍历allCourseItems，找到选中的课程，添加到当前系列中
  const selectedCourseIds: number[] = []
  for (const course of allCourseItems) {
    if (course.is_type === 1) {
      selectedCourseIds.push(course.id)
    }
  }
  if (selectedCourseIds.length === 0) {
    return ElNotification.warning({
      title: "当前未选择课程"
    })
  }
  emit("addCourse", selectedCourseIds.join(','))
}

const onAdd = (item: IncludeCourse) => {
  const index = allCourseItems.findIndex(c => c.id === item.id)
  allCourseItems[index].is_type = 1
}

const onRemove = (item: IncludeCourse) => {
  const index = allCourseItems.findIndex(c => c.id === item.id)
  allCourseItems[index].is_type = 0
}

const onSearch = async () => {
  try {
    const res = await CourseService.getAllCourseList({
      id: id.value,
      type: type.value,
      title: title.value,
    })
    if (res.data.code === 200) {
      courses.value = res.data.data || []
      if (courses.value) {
        // 遍历courses.value 与 allCourseItems，找到id相同的课程，并更新courses.value的is_type
        for (const course of courses.value) {
          const index = allCourseItems.findIndex(c => c.id === course.id)
          if (index !== -1) {
            course.is_type = allCourseItems[index].is_type
          }
        }
      }
    } else {
      ElNotification.error({
        title: "获取课程列表失败",
        message: res.data.msg,
        type: "error",
      })
    }
  } catch (error) {
    console.warn(error);
  }
}

defineExpose({
  init, hide
})
</script>

<template>
  <el-dialog align-center v-model="visible" :show-close="false" class="my-rounded-dialog">
    <div class="flex items-center px-1rem mb-1.5rem">
      <div class="text-#000000d9 mr-3rem">课程目录</div>
      <el-input
          class="my-rounded-full"
          v-model="title" style="width: 240px" placeholder="请输入课程标题"
          :suffix-icon="Search" @change="onSearch"></el-input>
    </div>
    <all-course-item
        v-for="(course, index) in courses"
        @on-add="onAdd"
        @onRemove="onRemove"
        :item="course"
        :darker="index % 2 === 1"/>
    <div class="flex justify-center items-center mt-1rem">
      <el-button type="primary" @click="onSure">确定</el-button>
      <el-button type="primary" plain @click="hide">取消</el-button>
    </div>
  </el-dialog>
</template>

<style scoped>
.my-rounded-full {
  --el-border-radius-base: 9999px;
}
</style>

<style>
.my-rounded-dialog {
  --el-dialog-border-radius: 16px;
}
</style>
